import { allAnalysis } from './analysis'
import { allTrend } from './trend'

const chartAnalysis = ['numAnalysis', 'historyNum'] // , 'lzAnalysis', 'hcAnalysis', 'dslsHistory', 'dslslz'
const chartTrend = ['basicTrend', 'dyTrend', 'dtTrend', 'hzTrend']
const headArr = ['万位', '千位', '百位', '十位', '个位']
const DtCompare = ['万位', '个位']

export const chartLot11P5 = {
  analysis: allAnalysis.filter(item => chartAnalysis.includes(item.id)),
  trend: allTrend.filter(item => chartTrend.includes(item.id)),
  headArr: headArr,
  resultMinNum: 1,
  resultMaxNum: 11,
  isResultRepeat: false,
  resultFillZero: true,
  DtCompare: DtCompare
}
